export const BASE_FILE_URL =
  'https://prodbuilderlinqstorage.blob.core.windows.net/homeowner-portal-docs' as const;

/**
 * Strips HTML tags from a string, returning plain text
 * @param html - HTML string to strip
 * @returns Plain text with HTML tags removed
 */
export function stripHtml(html?: string): string {
  if (!html) return '';
  return html.replace(/<[^>]+>/g, '');
}
